import React, { useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { PhoneLink, useErrorHandler, useAuth0, Footer } from '@ondeck/silkworm';
import Header from 'components/Header';
import { useAppData } from 'contexts/appContext';
import ErrorPage from 'pages/ErrorPage';
import { Container } from 'react-bootstrap';
import GlobalAlert from 'components/Common/GlobalAlert';

interface ContentProps {
  children?: React.ReactNode;
}

const AppContent = ({ children }: ContentProps) => {
  const intl = useIntl();
  const { hasError } = useErrorHandler();
  const { showLogin } = useAppData();
  const { isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      showLogin();
    }
  }, [isAuthenticated]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header/>
      <Container className="flex-grow-1 pb-4">
        {hasError ? <ErrorPage /> : <><GlobalAlert/>{children}</>}
      </Container>
      <Footer
        hours={intl.formatMessage({ id: 'footer.hours' })}
        phone={ <PhoneLink phoneNumber={intl.formatMessage({ id: 'common.contactNumber' })}/> }
        privacyHref="https://www.ondeck.com/privacy"
        privacyLink="Privacy Policy"
        securityHref="https://www.ondeck.com/security-policy"
        securityLink="Security Policy"
      >
        <p className="w-100 w-md-75 mt-3 mt-md-0">
          <FormattedMessage id="footer.body" />
        </p>
        <p>
          <FormattedMessage id="footer.copyright" />
        </p>
      </Footer>
    </div>
  );
};

export default AppContent;
